<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EbDVu/tc-custom/9781398405448.jpg?1705056298967" alt="This image is the cover for the book A History of London Boroughs Through Beer Goggles (South East Edition)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A History of London Boroughs Through Beer Goggles (South East Edition)
      </h1>
      <p class="bookDescription body article font2">
        <p>Discover facts, fiction, trivia and history of some of London’s boroughs that you may not have known before. All of this done whilst visiting some very interesting pubs and getting some exercise to boot! Why not read and discover about a reputed spy for Russia, who lived in a quiet suburb unbeknownst to her neighbours for decades after WWII? Or learn about Her Majesty the Queen’s beasts and what they mean? Find out about the Fighting Temeraire and the part it played in the Battle of Trafalgar. And finally, uncover the Great Fires of London, but not the one everyone talks about. A wealth of factoids which will astound your friends and family and could very well prepare you for some quiz nights!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cyril O'Brien
      </h2>
      
      <p class="authorDescription body article">Cyril O’Brien is a retired London Fire Brigade Borough Commander, who since leaving the LFB has moved in the world of Emergency Planning, and is currently working for the London Borough of Bexley.<br>Upon his retirement, finding additional time on his hands, Cyril made a foray into trying to write a book. His first effort being successful, prompted him to set about this edition as his number two.<br>He is married to Jackie and they have three very talented children, Georgina, Anne-Marie and Spencer. They have also been graced with three grandchildren, Coray, Anaya and Kaylan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3455caba